module.exports = __webpack_public_path__ + "media/P6.7f47cc04.mp4";